<template>
    <div ref="customReferenceModal" class="modal" id="modal-custom-reference" tabindex="-1" aria-labelledby="modalCustomReferenceLabel"
        aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-sm">
            <div class="modal-content">
                <div class="modal-body text-center py-4">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <strong>{{ $t('cart.custom_reference') }}</strong>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="customReference"
                                    v-model="customReference"
                                    maxlength="20"
                                    :placeholder="$t('cart.custom_reference_placeholder')"
                                >
                                <small class="form-text text-muted">{{ $t('cart.custom_reference_help') }}</small>
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <div class="d-flex justify-content-center">
                                <button class="btn btn-secondary" @click="cancel()">{{$t('button.cancel')}}</button>
                                <button class="btn btn-primary confirm-button ms-2" @click="save()">
                                    {{$t('button.ok')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Modal } from 'bootstrap'
    export default {
        data() {
            return {
                customReferenceModal: null,
                customReference: ''
            }
        },
        mounted() {
            // Check if user is prepayment user - if so, hide modal immediately
            if (this.isPrepaymentUser) {
                this.hide();
                return;
            }
            
            // Initialize the reference from the store if it exists
            this.customReference = this.$store.getters['Cart/GET_CUSTOM_REFERENCE'] || '';
            
            this.customReferenceModal = new Modal(this.$refs.customReferenceModal)
            this.show()
        },
        methods: {
            show() {
                this.customReferenceModal.show()
            },
            cancel() {
                this.hide()
            },
            hide() {
                this.$store.commit('Modal/DISABLE_CUSTOM_REFERENCE_MODAL')
                this.customReferenceModal.hide()
            },
            save() {
                this.$store.commit('Cart/SET_CUSTOM_REFERENCE', this.customReference)
                this.hide()
            }
        },
        computed: {
            isPrepaymentUser() {
                return this.$store.getters['Auth/IS_PREPAYMENT_USER']
            }
        }
    }
</script>

<style scoped>
.btn-secondary {
    color: white;
    background: #6c757d linear-gradient(180deg, #828a91, #6c757d) repeat-x;
    margin-right: 8px;
}

.foodstock-btn {
    width: 6rem;
}
</style>
